const FormTypes = {
  MASTERDATA: 'masterData',
  PERMISSIONS: 'permissions',
  OWNER: 'owner',
  DELETE: 'delete',
  PHOTO: 'photo'
};

export default FormTypes;
